import BaseModel from './BaseModel'

export default class Insurer extends BaseModel {
  // ... Insurer-specific methods or overrides ...
}
